import PropTypes from 'prop-types';
import { createContext, useContext } from 'react';
import { useTheme } from '@mui/material/styles';

const RtlContext = createContext(undefined);

export function useRtl() {
    const rtlContextValue = useContext(RtlContext);
    const theme = useTheme();

    if (typeof rtlContextValue === 'boolean') {
        return rtlContextValue;
    }

    return theme?.direction === 'rtl';
}

export function RtlProvider({ children, value }) {
    return <RtlContext.Provider value={value}>{children}</RtlContext.Provider>;
}

RtlProvider.propTypes = {
    children: PropTypes.node,
    value: PropTypes.bool
};

export default RtlProvider;
